import Immutable from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import { CHAT_STATUS } from '../constants/constants';
import * as msgUtils from '../functions/messageUtils';
import initialState from './initialState';
import { FeatureRooms, Room } from 'redhotpie-shared-lib/models/chatRoom';
import ChatRoom from 'modules/ChatRoom';
import moment from 'moment';

// export interface IGroupChatState {
//   optionProfileSummaryModal: any;
//   toggleCloseLiveStream: boolean;
//   isLoadingMemberData: boolean;
//   membersJoining: any; // {[roomJid: string]: any[]}
//   freeChatBanner: any;
//   closingTime: Date;
//   displayFreeChat: boolean;
//   flagLoadMessage: boolean;
//   isAPIDataLoaded: boolean;
//   isLoadingGroups: boolean;
//   isLoadGroupsFailed: boolean;
//   authorized: any;
//   data: ChatRoom[];
//   selectedGroup: Room;
//   nextSelectedGroup: Room;
//   isUserBanned: boolean;
//   waitingProgress: boolean;
//   profileNoteMember: any;
//   isSortLiveStream: boolean;
//   isAlReadyLogged: boolean;
//   groupCanBeInvite: {
//     loading: boolean;
//     data: any[];
//   };
//   groupShouldSendJoinGroupChatMessage: any[];
//   roomJidShouldSendJoinGroupChatMessage: any[];
//   roomJidSendingJoinGroupChatMessage: any[];
//   groupChatMessageStatus: {
//     sendMessageBan: boolean;
//     sendMessageBanExpiry: any; // Date or timestamp
//     sendPhotoBan: boolean;
//     sendPhotoBanExpiry: any;
//   };
//   featureRooms: FeatureRooms[];
//   isLoadedFeatureRooms: boolean;
// }

// Action type definition
interface IAction {
  type: string;
  data?: any;
  rooms?: any;
  authorized?: any;
  room?: any;
  roomJid?: string;
  memberData?: any;
  members?: any;
  isLocal?: boolean;
  userBanedId?: string;
  loading?: boolean;
}

export default function groupsChatReducer(state: any = initialState.groupChat, action: IAction): any {
  switch (action.type) {
    case types.UPDATE_OPTIONS_PROFILE_SUMMARY_SUCCESS: {
      console.log('UPDATE_OPTIONS_PROFILE_SUMMARY_SUCCESS', action.data);
      return state.set('optionProfileSummaryModal', action.data);
    }
    case types.TOGGLE_CLOSE_LIVE_STREAM: {
      return state.set('toggleCloseLiveStream', action.data);
    }
    case types.ADD_JOINING_MEMBER_PUBLIC_GROUP_CHAT: {
      const members = state.membersJoining[action.roomJid!] || [];
      return state.setIn(['membersJoining', action.roomJid], [...members, action.memberData]);
    }
    case types.REMOVE_JOINING_MEMBER_PUBLIC_GROUP_CHAT: {
      const members = state.membersJoining[action.roomJid!] || [];
      return state.setIn(
        ['membersJoining', action.roomJid],
        members.filter((m: any) => m.jid !== action.memberData.jid)
      );
    }
    case types.CLEAR_JOINING_MEMBER_PUBLIC_GROUP_CHAT: {
      return state.set('membersJoining', {});
    }
    case types.LOADING_PUBLIC_GROUP_CHAT_MEMBER: {
      return state.set('isLoadingMemberData', action.data);
    }
    case types.CHAT_UPDATE_GROUP_SUCCESS: {
      let newState = state.set('data', action.rooms);
      newState = newState.set('authorized', action.authorized);
      newState = newState.set('isAPIDataLoaded', true);

      return newState.set('isLoadGroupsFailed', false).set('isLoadingGroups', false);
    }

    case types.UPDATE_FEATURE_ROOMS_DATA: {
      return state.set('featureRooms', action.data).set('isLoadedFeatureRooms', true);
    }

    case types.UPDATE_FEATURE_ROOM_DATA: {
      const featureRooms = [...(state.featureRooms.asMutable() || [])];
      featureRooms.forEach((room: any) => {
        let roomUpdated = { ...room };
        if (roomUpdated.roomJid === action.room.roomJid) {
          roomUpdated = { ...roomUpdated, ...action.room };
        }
        return roomUpdated;
      });
      return state.set('featureRooms', featureRooms);
    }

    case types.UPDATE_SELECTED_GROUP_DATA: {
      return state.set('selectedGroup', { ...state.selectedGroup, ...action.data });
    }

    case types.CHAT_UPDATE_ROOMS_DATA: {
      return state.set('data', action.rooms);
    }

    case types.REMOVE_PUBLIC_GROUP_CHAT: {
      const data = [...state.data].filter((room: any) => room && room.roomJid !== action.roomJid);
      return state.set('data', data);
    }

    case types.UPDATE_BANNER_FREE_CHAT: {
      return state
        .set('freeChatBanner', action.data.freeChatBanner)
        .set('displayFreeChat', action.data.displayFreeChat)
        .set('closingTime', action.data.closingTimeInDate)
        .set('featureRooms', action.data.featureRooms || []);
    }

    case types.TOGGLE_REMINDER_FEATURE_CHAT_ROOM_SUCCESS: {
      const { featureRooms } = Immutable.asMutable(state);
      const roomId = action.data;
      const newFeatureRooms = featureRooms.map((r: any) => {
        if (r.roomId === roomId) return { ...r, hasReminder: !r.hasReminder };
        return r;
      });
      return state.set('featureRooms', newFeatureRooms);
    }

    case types.RESET_CLOSING_TIME_GROUP_CHAT: {
      return state.set('closingTime', null);
    }

    case types.SET_IS_SORT_LIVE_STREAM: {
      let members = [...state.selectedGroup.members];
      members = members.sort((a, b) => b.joinedAt - a.joinedAt);
      if (action.data) {
        const listMemberLiveStream = members.filter((i: any) => i.status === CHAT_STATUS.LIVE);
        const listMemberNotLiveStream = members.filter((i: any) => i.status !== CHAT_STATUS.LIVE);
        members = [...listMemberLiveStream, ...listMemberNotLiveStream];
      }
      return state.set('isSortLiveStream', action.data).setIn(['selectedGroup', 'members'], members);
    }

    case types.UPDATE_CHAT_ROOM_AUTHORIZED_SUCCESS: {
      return state.set('authorized', action.data);
    }

    case types.CHAT_UPDATE_GROUP_FAIL: {
      const data: any[] = [];
      [...state.data, ...state.featureRooms].forEach((g: any) => {
        const gr = Object.assign({}, g, { occupants: 0 });
        data.push(gr);
      });

      return state.set('data', data).set('isLoadGroupsFailed', true).set('isLoadingGroups', false).set('isAPIDataLoaded', true);
    }

    case types.CHAT_UPDATE_GROUP_REQUEST: {
      return state.set('isLoadingGroups', true);
    }

    case types.JOIN_CHAT_ROOM_SUCCESS: {
      const group = state.selectedGroup.asMutable() || {};
      const roomSelected = [...state.data, ...state.featureRooms].filter((r: any) => {
        return r.roomJid === action.room.roomJid;
      });
      let newState = state;
      if (roomSelected.length > 0) {
        const selected = Object.assign(group, roomSelected[0]);
        newState = newState.set('selectedGroup', selected);
      }
      newState = newState.set('isUserBanned', false);
      return newState.set('waitingProgress', false).set('flagLoadMessage', !state.flagLoadMessage);
    }
    case types.QUIT_CHAT_ROOM_SUCCESS: {
      const initRoom = initialState.groupChat.selectedGroup;
      let newState = state.set('selectedGroup', initRoom);
      return newState.set('waitingProgress', false);
    }
    case types.SET_NEXT_CHAT_ROOM_SUCCESS:
      return state.set('nextSelectedGroup', action.room);

    case types.GET_LIST_USERS_STATUS_SUCCESS: {
      const { members, isLocal } = action;
      let data: any[] = [];
      if (isLocal) {
        members.forEach((m: any) => {
          let user = { ...m, status: 1 };
          action.data.forEach((u: any) => {
            // eslint-disable-next-line eqeqeq
            if (user.name == u.name && u.status) {
              user = Object.assign({}, user, {
                status: u.status,
                joinedAt: u.joinedAt,
              });
            }
          });
          if (!user.joinedAt) {
            user.joinedAt = moment(new Date()).valueOf();
          }
          data.push(user);
        });
      } else {
        members.forEach((m: any) => {
          let user = { ...m, status: 1 };
          action.data.forEach((u: any) => {
            if (msgUtils.addPrefixAndSuffix(user.name) === u.userJid && u.status) {
              user = Object.assign({}, user, {
                status: u.status,
                joinedAt: u.joined_at,
              });
            }
          });
          data.push(user);
        });
      }
      // Sort by DES joinedAt time, who join first will be in the end of list

      data = data.sort((a, b) => b.joinedAt - a.joinedAt);
      if (state.isSortLiveStream) {
        const listMemberLiveStream = data.filter((i: any) => i.status === CHAT_STATUS.LIVE);
        const listMemberNotLiveStream = data.filter((i: any) => i.status !== CHAT_STATUS.LIVE);
        return state
          .set('isLoadingMemberData', false)
          .setIn(['selectedGroup', 'members'], [...listMemberLiveStream, ...listMemberNotLiveStream]);
      }
      return state.set('isLoadingMemberData', false).setIn(['selectedGroup', 'members'], data);
    }
    case types.UPDATE_USER_STATUS_SUCCESS: {
      const users = state.selectedGroup.members.asMutable() || [];
      const member: any[] = [];
      users.forEach((m: any) => {
        let user = Object.assign({}, m);
        if (action.data.userId.toString() === m.name.toString()) {
          user = Object.assign(user, { status: parseInt(action.data.status, 10) });
        }
        member.push(user);
      });
      return state.setIn(['selectedGroup', 'members'], member);
    }

    case types.UPDATE_USER_STATUS_LOCAL_SUCCESS: {
      const users = state.selectedGroup.members.asMutable() || [];
      const member: any[] = [];
      users.forEach((m: any) => {
        let user = Object.assign({}, m);
        if (action.data.userId === m.name) {
          user = Object.assign(user, { status: parseInt(action.data.status, 10) });
        }
        member.push(user);
      });
      return state.setIn(['selectedGroup', 'members'], member);
    }

    case types.USER_LOGOUT_SUCCESS: {
      return initialState.groupChat;
    }

    case types.UPDATE_LIVE_MEMBER: {
      const rooms = [...state.data].map((room: any) => {
        const newRoom = Object.assign({}, room);
        action.data.forEach((item: any) => {
          if (item.roomId === newRoom.roomId) {
            newRoom.liveMembers = item.total.toString();
          }
        });
        return newRoom;
      });
      const featureRooms = [...(state.featureRooms || [])].map((room: any) => {
        const newRoom = Object.assign({}, room);
        action.data.forEach((item: any) => {
          if (item.roomId === newRoom.roomId) {
            newRoom.liveMembers = item.total.toString();
          }
        });
        return newRoom;
      });
      return state.set('data', rooms).set('featureRooms', featureRooms);
    }
    case types.SET_WAITING_PROGRESS_GROUP_CHAT_SUCCESS:
      return state.set('waitingProgress', action.data);

    case types.BANNED_SUCCESS:
      return state.set('isUserBanned', true);
    case types.UPDATE_AL_READY_LOGGED:
      return state.set('isAlReadyLogged', action.data);

    case types.SET_PROFILE_NOTE_MEMBER_SUCCESS:
      return state.setIn(['profileNoteMember', action.userBanedId!], action.data);
    case types.LOADING_GROUP_CHAT_CAN_BE_INVITE: {
      return state.setIn(['groupCanBeInvite', 'loading'], action.loading);
    }
    case types.GET_GROUP_CHAT_CAN_BE_INVITE_SUCCESS: {
      return state.merge({
        groupCanBeInvite: {
          loading: false,
          data: action.data,
        },
      });
    }
    case types.ADD_GROUP_SHOULD_SEND_JOIN_MESSAGE: {
      return state.set('groupShouldSendJoinGroupChatMessage', [...state.groupShouldSendJoinGroupChatMessage, action.data]);
    }
    case types.REMOVE_GROUP_SHOULD_SEND_JOIN_MESSAGE: {
      return state.set(
        'groupShouldSendJoinGroupChatMessage',
        state.groupShouldSendJoinGroupChatMessage.filter((conv: any) => conv.roomJid !== action.data)
      );
    }
    case types.ADD_ROOMJID_SHOULD_SEND_JOIN_MESSAGE: {
      return state.set('roomJidShouldSendJoinGroupChatMessage', [...state.roomJidShouldSendJoinGroupChatMessage, action.data]);
    }
    case types.ADD_ROOMJID_SENDING_JOIN_MESSAGE: {
      return state.set(
        'roomJidSendingJoinGroupChatMessage',
        Array.from(new Set([...state.roomJidSendingJoinGroupChatMessage, action.data]))
      );
    }
    case types.REMOVE_ROOMJID_SHOULD_SEND_JOIN_MESSAGE: {
      return state
        .set(
          'groupShouldSendJoinGroupChatMessage',
          state.roomJidShouldSendJoinGroupChatMessage.filter((roomJid: any) => roomJid !== action.data)
        )
        .set(
          'roomJidSendingJoinGroupChatMessage',
          state.roomJidSendingJoinGroupChatMessage.filter((roomJid: any) => roomJid !== action.data)
        );
    }
    case types.UPDATE_GROUP_CHAT_MESSAGE_STATUS: {
      return state.set('groupChatMessageStatus', action.data);
    }
    default:
      return state;
  }
}
